import React, { useEffect, useState } from 'react';
import { useSite } from '../../contexts/SiteContext';
import { api } from '../../services/api';

const SiteDebug: React.FC = () => {
  const site = useSite();
  const [apiResponse, setApiResponse] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const testApi = async () => {
      try {
        const response = await api.get('/api/teams/teams/');
        setApiResponse(response.data);
      } catch (error) {
        setApiResponse({ error: (error as Error).toString() });
      } finally {
        setLoading(false);
      }
    };
    testApi();
  }, []);

  return (
    <div className="p-8 bg-gray-900 text-white">
      <h1 className="text-3xl font-bold mb-6">Site Debug Information</h1>
      
      <div className="space-y-4">
        <div className="bg-gray-800 p-4 rounded">
          <h2 className="text-xl font-semibold mb-2">Current Location</h2>
          <p>Hostname: {window.location.hostname}</p>
          <p>Port: {window.location.port || '(default)'}</p>
          <p>Full Host: {window.location.host}</p>
        </div>

        <div className="bg-gray-800 p-4 rounded">
          <h2 className="text-xl font-semibold mb-2">Site Configuration</h2>
          <p>Site Name: {site.name}</p>
          <p>Sport: {site.sport || 'All Sports'}</p>
          <p>Level: {site.level || 'All Levels'}</p>
          <p>Is Main Site: {site.isMainSite ? 'Yes' : 'No'}</p>
          <p>Is Sport Specific: {site.isSportSpecific ? 'Yes' : 'No'}</p>
        </div>

        <div className="bg-gray-800 p-4 rounded">
          <h2 className="text-xl font-semibold mb-2">Theme Colors</h2>
          <div className="flex gap-4">
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded" 
                style={{ backgroundColor: site.theme.primary[500] }}
              />
              <p>Primary</p>
              <p className="text-xs">{site.theme.primary[500]}</p>
            </div>
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded" 
                style={{ backgroundColor: site.theme.secondary[500] }}
              />
              <p>Secondary</p>
              <p className="text-xs">{site.theme.secondary[500]}</p>
            </div>
            <div className="text-center">
              <div 
                className="w-20 h-20 rounded" 
                style={{ backgroundColor: site.theme.accent[500] }}
              />
              <p>Accent</p>
              <p className="text-xs">{site.theme.accent[500]}</p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800 p-4 rounded">
          <h2 className="text-xl font-semibold mb-2">API Test</h2>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div>
              <p>Teams Count: {apiResponse?.count || 0}</p>
              <p>API Filters: {JSON.stringify(site.getApiFilters())}</p>
              {apiResponse?.results?.slice(0, 3).map((team: any) => (
                <p key={team.id}>- {team.name} ({team.sport_name})</p>
              ))}
            </div>
          )}
        </div>

        <div className="bg-gray-800 p-4 rounded">
          <h2 className="text-xl font-semibold mb-2">Test Other Sites</h2>
          <div className="flex gap-2">
            <a href="http://localhost:5184" className="text-blue-400 underline">Parent Site</a>
            <a href="http://nfl.localhost:5184" className="text-blue-400 underline">NFL</a>
            <a href="http://nba.localhost:5184" className="text-blue-400 underline">NBA</a>
            <a href="http://mlb.localhost:5184" className="text-blue-400 underline">MLB</a>
            <a href="http://nhl.localhost:5184" className="text-blue-400 underline">NHL</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteDebug;